import { render, staticRenderFns } from "./ComplianceReport.vue?vue&type=template&id=18970aee"
import script from "./ComplianceReport.vue?vue&type=script&lang=js"
export * from "./ComplianceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports